import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation DeleteActivityNotification($id: ID!) {
  deleteActivityNotification(id: $id){
    id
  }
}`;

function deleteActivityNotification(id) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
    },
  }).then((res) => res.data.deleteActivityNotification);
}

export default deleteActivityNotification;
